import config from "@/config";
import { postApiRequest } from "@/services/api-request";

export interface PollingMessage {
  id: string;
  eventName: string;
  data: unknown;
  connectionId?: string;
  userId?: string;
  printHouseId?: string;
  createdAt?: number;
}

export interface ConnectResponse {
  connectionId: string;
}

export interface PollResponse {
  messages: PollingMessage[];
}

const connect = async (
  eventNames: string[],
  ctx?: { userId?: string; printHouseId?: string }
): Promise<ConnectResponse> => {
  const result = await postApiRequest("/v1/polling/connect", {
    eventNames,
    ...ctx,
  });

  if (!result.success || !result.data?.connectionId) {
    throw new Error(result.message || "Failed to connect polling session");
  }

  return { connectionId: result.data.connectionId };
};

const poll = async (
  connectionId: string,
  eventNames: string[],
  ctx?: { userId?: string; printHouseId?: string }
): Promise<PollResponse> => {
  const result = await postApiRequest("/v1/polling/poll", {
    connectionId,
    eventNames,
    ...ctx,
  });

  if (!result.success) {
    throw new Error(result.message || "Failed to poll");
  }

  return { messages: result.data?.messages ?? [] };
};

const disconnect = (connectionId: string): void => {
  const payload = JSON.stringify({ connectionId });
  const url = `${config.api_server}/v1/polling/disconnect`;

  if (typeof navigator !== "undefined" && navigator.sendBeacon) {
    const blob = new Blob([payload], { type: "application/json" });
    if (navigator.sendBeacon(url, blob)) {
      return;
    }
  }

  void postApiRequest("/v1/polling/disconnect", { connectionId }).catch(() => {});
};

export const pollingService = {
  connect,
  poll,
  disconnect,
};
